<ng-container *ngIf="!text">
  <fa-icon [icon]="faSpinnerThird" animation="spin" class="me-1"></fa-icon> Loading...
</ng-container>

<ng-container *ngIf="text">
  <div [outerHTML]="text"></div>
</ng-container>
